// extracted by mini-css-extract-plugin
export default {"dialog__content":"ImpersonationIcon_dialog__content__fPeX7","person-search":"ImpersonationIcon_person-search__ZTTZK"};